
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from 'vue';
export default defineComponent({
  props: {
    isLoadingDone: Boolean,
    buttonUrl: String,
    logoGuid: String,
  },
  methods: {
    openPitchYouTab() {
      const url = 'https://www.pitchyou.de'; // URL, die geöffnet werden soll
      window.open(url, '_blank');
    },
  },
  setup(props) {
    const targetUrl = ref('');
    const useWindowOpen = ref(false);
    const screenHeight = ref(window.innerHeight);
    const logoPath = ref('/api/media/v1/logo/');

    const updateScreenHeight = () => {
      screenHeight.value = window.innerHeight;
    };

    const currentHeight = computed(() => {
      return {
        height: screenHeight.value + 'px',
      };
    });

    const openUrl = () => {
      if (props.buttonUrl) {
        if (useWindowOpen.value) {
          window.open(props.buttonUrl, '_blank');
        } else {
          window.location.href = props.buttonUrl;
        }
        useWindowOpen.value = !useWindowOpen.value;
      }
    };

    onMounted(() => {
      window.addEventListener('resize', updateScreenHeight);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateScreenHeight);
    });

    watch(
      () => props.buttonUrl,
      (newButtonUrl) => {
        targetUrl.value = newButtonUrl ?? '';
      }
    );

    return {
      openUrl,
      targetUrl,
      currentHeight,
      logoPath,
    };
  },
});
